<template>
  <div>

    <vs-button @click="sortById">To original order</vs-button>

   <vs-divider position="center">Today</vs-divider>

  <vs-row
    vs-align="flex-start"
    vs-type="flex" vs-justify="center" vs-w="12">

    <vs-col vs-justify="center" vs-align="center" vs-w="4">

      <!-- <div class="tasks-box"> -->
        <draggable
          v-if="tasksAny"
          v-model="todayTasks"
          handle=".task-handle"
          ghost-class="ghost-task"
          :sort="true"
          group="a"
          drag-class="task-drag"
          @start="dragging = true"
          @end="dragging = false"
          class="tasks-box"
          :class="{ 'tasks-box__active': dragging}"
        >
            <!-- <transition-group type="transition" :name="!dragging ? 'flip-list' : null"> -->

              <template v-for="task in todayTasks">
                  <Task
                  :key="task.id"
                    :task="task"
                    class="mb-2 task-handle"
                  />
              </template>

            <!-- </transition-group> -->
          </draggable>
      <!-- </div> -->


    </vs-col>


 <vs-col vs-justify="center" vs-align="center" vs-w="4">


    <draggable
      v-if="tasksAny"
      v-model="inProgressTasks"
      handle=".task-handle"
      ghost-class="ghost-task"
      :sort="true"
      group="a"
      drag-class="task-drag"
      @start="dragging = true"
      @end="dragging = false"
      class="tasks-box"
      :class="{ 'tasks-box__active': dragging}"
    >
        <!-- <transition-group type="transition" :name="!dragging ? 'flip-list' : null"> -->

          <template v-for="task in inProgressTasks">
              <Task
              :key="task.id"
                :task="task"
                class="mb-2 task-handle"
              />
          </template>

        <!-- </transition-group> -->
      </draggable>

    </vs-col>

    <vs-col vs-justify="center" vs-align="center" vs-w="4">

    <draggable
      v-if="tasksAny"
      v-model="doneTasks"
      handle=".task-handle"
      ghost-class="ghost-task"
      :sort="true"
      group="a"
      drag-class="task-drag"
      @start="dragging = true"
      @end="dragging = false"
      class="tasks-box"
      :class="{ 'tasks-box__active': dragging}"
    >
        <!-- <transition-group type="transition" :name="!dragging ? 'flip-list' : null"> -->

          <template v-for="task in doneTasks">
              <Task
              :key="task.id"
                :task="task"
                class="mb-2 task-handle"
              />
          </template>

        <!-- </transition-group> -->
      </draggable>

    </vs-col>

  </vs-row>

    <vs-divider position="center">Someday</vs-divider>

    <draggable
      v-if="tasksAny"
      v-model="tasks"
      handle=".task-handle"
      ghost-class="ghost-task"
      :sort="true"
      group="a"
      drag-class="task-drag"
      @start="dragging = true"
      @end="dragging = false"
      class="tasks-box"
      :class="{ 'tasks-box__active': dragging }"
    >
        <!-- <transition-group> -->

        <template v-for="task in tasks">
            <Task
              :key="task.id"
              :task="task"
              class="mb-2 task-handle"
            />
          </template>
        <!-- </transition-group> -->
      <vs-button slot="header">Add</vs-button>
    </draggable>


<!--

    <TaskCard
      style="max-width: 500px"
      title="Implement tasks for self-improvee"
      title-color="primary"
      :startCollapsed="true"
      :collapseAction="true"
      :showProgress="true"
      :progressPercent="50"
      :done="false"
      collapsable
    >
      <div>
         <div class="flex items-center">
        <feather-icon icon="CheckSquareIcon" class="w-5 mr-2" />
        <p >Subgoal1</p>
      </div>
          <div class="flex items-center">
        <feather-icon icon="SquareIcon" class="w-5 mr-2" />
        <p >Subgoal2</p>
      </div>
      </div>

    </TaskCard>

    <div class="my-2"></div>

    <TaskCard
      style="max-width: 500px"
      title="Some Goal N2"
      title-color="dark"
      :startCollapsed="true"
      :collapseAction="true"
      :showProgress="false"
      :done="false"
      collapsable
    >
      <div>
         <div class="flex items-center">
        <feather-icon icon="PlusIcon" class="w-5 mr-2" />
        <vs-input class="inputx skeleton-input" placeholder="Add Sub Task" v-model="addSubTaskSkeleton" />
      </div>
      </div>

    </TaskCard>

     <div class="my-2"></div>

    <TaskCard
      style="max-width: 500px"
      title="Some Goal N2"
      title-color="dark"
      :startCollapsed="true"
      :collapseAction="true"
      :showProgress="false"
      :done="true"
      card-background="primary"
      collapsable
    >
      <div>
         <div class="flex items-center">
        <feather-icon icon="PlusIcon" class="w-5 mr-2" />
        <vs-input class="inputx skeleton-input" placeholder="Add Sub Task" v-model="addSubTaskSkeleton" />
      </div>
      </div>

    </TaskCard> -->

  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Task from './Task'

export default {
  components: {
    draggable,
    Task
  },
  data () {
    return {
      dragging: false,
      todayTasks: [],
      inProgressTasks: [],
      doneTasks: [],
      tasksAny: true,
      tasks: [
        {
          id: 1,
          title: 'Task1',
          done: true,
          opened: true,
          subtasks: [
            {
              id: 1,
              title: 'Subtask1',
              done: true
            },

            {
              id: 2,
              title: 'Subtask2',
              done: false
            },

            {
              id: 3,
              title: 'Subtask3',
              done: true
            },
          ]
        },
        {
          id: 2,
          title: 'Task2',
          done: false,
          opened: false,
          subtasks: []
        },
        {
          id: 3,
          title: 'Task3',
          done: true,
          opened: false,
          subtasks: []
        },
        {
          id: 4,
          title: 'Task4',
          done: false,
          opened: true,
          subtasks: []
        },
        {
          id: 5,
          title: 'Task4',
          done: false,
          opened: true,
          subtasks: []
        },
        {
          id: 6,
          title: 'Task4',
          done: false,
          opened: true,
          subtasks: []
        },
        {
          id: 7,
          title: 'Task4',
          done: false,
          opened: true,
          subtasks: []
        },
        {
          id: 8,
          title: 'Task4',
          done: false,
          opened: true,
          subtasks: []
        },
      ]
      // addSubTaskSkeleton: null
    }
  },
  methods: {
    sortById () {
      this.tasks = this.tasks.sort((a, b) => a.id - b.id)
    }
  }
}

</script>

<style lang="scss">
.skeleton-input {
  .vs-inputx {
    border: none !important;
    background: transparent !important;
  }

}
.task-handle {
  cursor: move;
}
.task-drag {
  cursor: move !important;
  background: red !important;
}
.ghost-task {
  opacity: 0.3;
}

.flip-list-move {
  transition: transform 0.5s;
}

.tasks-box {
  border-style: dashed;
  border-width: 2px;
  border-radius: 8px;
  border-color: rgba(112, 112, 112, 0.4);
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  min-height: 400px
}

.tasks-box__active {
  border-color: rgba(112, 20, 112, 0.8);
}
</style>
